import { render } from "./FrequencyCheck.vue?vue&type=template&id=73ee3146&ts=true"
import script from "./FrequencyCheck.ts?vue&type=script&lang=ts&external"
export * from "./FrequencyCheck.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__